import { render, staticRenderFns } from "./DialogNewRequestForm.vue?vue&type=template&id=71409c92&"
import script from "./DialogNewRequestForm.vue?vue&type=script&lang=js&"
export * from "./DialogNewRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports